import { makeAutoObservable, runInAction } from 'mobx'
import { FormEvent } from 'react'
import { notification } from 'antd'
import { openApi } from '../../helpers/request'
import { storeLocal } from '../../helpers/stores'
import userController from '../user/controllers/user.controller'
import i from '../../translations/i'
import { ProjectRow, projectMatches } from '../../components/project_card/ProjectCard'

// Суперадминка: то, что раньше было в /admin старого API. Сервер пускает в protected/*
// только суперпользователя, здесь проверка нужна лишь чтобы не показывать разделы остальным

export interface SuperProject extends ProjectRow {
    black_mark: boolean
    wl_id: number | null
    // null — сервер не смог получить список баз
    has_database: boolean | null
}

class superController {
    isSuper = false
    checked = false

    projects: SuperProject[] = []
    projectsLoading = false
    projectsSearch = ''

    // Строка kssettings текущего проекта: как пришла и как отредактирована
    fields: Record<string, any> = {}
    initialFields: Record<string, any> = {}
    fieldsLoaded = false
    fieldsSearch = ''
    // Логотипы, выбранные файлом: уходят на сервер файлом, а в fields на это время — ссылка для превью
    files: Record<string, File> = {}

    constructor() {
        makeAutoObservable(this)
    }

    async check() {
        const user = await userController.decrypt('user')
        runInAction(() => {
            this.isSuper = !!(user && user.super)
            this.checked = true
        })
    }

    getProjects() {
        this.projectsLoading = true

        openApi('get', '/protected/projects')
            .then(result => runInAction(() => this.projects = result.data ?? []))
            .catch(err => console.log(err))
            .finally(() => runInAction(() => this.projectsLoading = false))
    }

    get filteredProjects(): SuperProject[] {
        const query = this.projectsSearch.trim().toLowerCase()
        if (!query) return this.projects

        return this.projects.filter(project => projectMatches(project, query))
    }

    getFields() {
        openApi('get', '/settings')
            .then(result => runInAction(() => {
                const { project, themes, ...row } = result.data ?? {}
                this.fields = { ...row }
                this.initialFields = { ...row }
                this.files = {}
                this.fieldsLoaded = true
            }))
            .catch(err => console.log(err))
    }

    setField(name: string, value: any) {
        this.fields[name] = value
        delete this.files[name]
    }

    setFile(name: string, file: File) {
        this.fields[name] = URL.createObjectURL(file)
        this.files[name] = file
    }

    get changedFields(): string[] {
        // Флаги приходят то true/false, то 0/1
        const normalize = (value: any) => value === true ? '1' : value === false ? '0' : `${value ?? ''}`

        return Object.keys(this.fields).filter(key => normalize(this.fields[key]) !== normalize(this.initialFields[key]))
    }

    saveFields(e: FormEvent) {
        e.preventDefault()

        const changed = this.changedFields
        if (!changed.length) {
            notification.info({ message: i.t('superAdmin:fields.nothing') })
            return
        }

        const data = new FormData()
        changed.forEach(key => {
            const value = this.fields[key]

            if (this.files[key]) {
                data.append(key, this.files[key])
            } else if (Array.isArray(value)) {
                // Языки: сервер сохраняет список JSON-массивом
                value.forEach(item => data.append(`${key}[]`, `${item}`))
            } else {
                // 'null' сервер сохраняет как NULL
                data.append(key, value === null || value === undefined || value === '' ? 'null' : `${value}`)
            }
        })

        openApi('post', '/setting/edit', data)
            .then(async result => {
                const { project, themes, ...row } = result.data ?? {}

                runInAction(() => {
                    this.fields = { ...row }
                    this.initialFields = { ...row }
                    this.files = {}
                })

                // Тариф и метку админка читает из локального хранилища — обновляем, чтобы не ждать перезахода
                const cached = await userController.decrypt('project')
                if (cached) userController.encrypt('project', { ...cached, ...row })
                if (row.pricing_plan !== undefined && row.pricing_plan !== null) storeLocal.set('pricing_plan', +row.pricing_plan)
                if (row.black_mark !== undefined) storeLocal.set('black_mark', !!+row.black_mark)

                notification.success({ message: i.t('def:success.complete') })
            })
            .catch(err => notification.error({ message: err?.response?.data?.data?.message ?? i.t('def:errors.error') }))
    }
}

export default new superController()
